/*
 * @Author: hzc
 * @Date: 2024-12-09 09:25:17
 * @LastEditors: hzc
 * @LastEditTime: 2025-07-15 18:39:14
 * @Description: -
 */
import { createI18n } from "vue-i18n";
import zhCN from "@/lang/zh-CN";
import en from "@/lang/en";
import fr from "@/lang/fr";
import ar from "@/lang/ar";
import es from "@/lang/es";
import id from "@/lang/id";
import pt from "@/lang/pt";
import kr from "@/lang/kr";
import jp from "@/lang/jp";
import de from "@/lang/de";

import Cookies from "js-cookie";
// 语言包

const i18n = createI18n({
  legacy: false,
  fallbackLocale: "en", // set fallback locale
  locale: Cookies.get("lang") || "en", // 初始化中文
  messages: {
    "zh-CN": zhCN,
    en: en,
    fr: fr,
    ar: ar,
    es: es,
    id: id,
    pt: pt,
    kr: kr,
    jp: jp,
    de: de,
  },
});
export default i18n;
